module.exports = __webpack_public_path__ + "img/roundtable.02aebc0a.svg";